import React, { useState } from "react";
import { FiLayers } from "react-icons/fi";
import FileInsertion from "./FileInserton";
import FileUpdate from "./FIleUpdate";
const PDFInsertionMaster = () => {
  const [activePage, setActivePage] = useState("Insert");
  const handleBtnClick = (page) => {
    setActivePage(page);
  };

  //   useEffect(() => {
  //     if (payload?.activeReportPage) {
  //       setActiveReportPage(payload.activeReportPage);
  //     }
  //   }, [payload, setActiveReportPage]);

  const pages = ["Insert", "Update"];

  return (
    <div>
      <div
        className="card border-0 shadow-sm mb-3"
        style={{ borderRadius: "14px", overflow: "hidden" }}
      >
        <div
          className="card-body p-3 p-md-4 text-center"
          style={{
            background:
              "linear-gradient(110deg, #063b87 0%, #0a57bb 65%, #087344 100%)",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
              style={{
                width: "46px",
                height: "46px",
                background: "rgba(255,255,255,0.16)",
                color: "#fff",
                fontSize: "23px",
              }}
            >
              <FiLayers />
            </div>

            <div>
              <h5 className="text-white fw-bold  mb-1">File Management</h5>
              <p className="text-white-50 small mb-0">
                Insert and update Manage files
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="ms-2 me-2">
        <div className="reports-navbar ">
          <div className="reports-navbar-inner">
            <div className="reports-title">
              <span className="reports-title-line"></span>
              <span>Insert</span>
            </div>

            <div className="reports-buttons">
              {pages.map((pageName, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleBtnClick(pageName)}
                  className={`report-nav-btn ${
                    activePage === pageName ? "report-nav-active" : ""
                  }`}
                >
                  <span className="report-nav-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="report-nav-text">{pageName}</span>

                  <span className="report-nav-arrow">›</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      {activePage === "Insert" && <FileInsertion />}
      {activePage === "Update" && <FileUpdate />}
    </div>
  );
};
export default PDFInsertionMaster;
